// extracted by mini-css-extract-plugin
module.exports = {"summary":"SIzOIp9IZj71m__EqnWM_","row":"_8MwGmAMlrmZxszEXpdWuX","rowLand":"_83mk5K6IfoafU0OPbC0-V"};